import { Component, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core'
import { MatDialogRef as MatDialogRef } from '@angular/material/dialog'
import { Router } from '@angular/router'
import { AllowedDialogsService } from 'app/_angular/service/allowed-dialogs.service'

import { Subject } from 'rxjs'
import { takeUntil } from 'rxjs/operators'

@Component({
  selector: 'ViiaLoginFailedDialog',
  templateUrl: './viia-login-failed.dialog.html',
  styleUrls: ['./viia-login.dialog.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ViiaLoginFailedDialog implements OnInit, OnDestroy {
  commonError: string
  extraTextExpanded: boolean = false

  private _ngUnsubscribe = new Subject<void>()

  constructor(
    private _dialogRef: MatDialogRef<ViiaLoginFailedDialog>,
    private _router: Router,
    private _allowedDialogsService: AllowedDialogsService,
  ) {}

  ngOnInit() {
    this._dialogRef
      .beforeClosed()
      .pipe(takeUntil(this._ngUnsubscribe))
      .subscribe(() => {
        this._allowedDialogsService.allowAll()
        this._router.navigate(['/'])
      })
  }

  sulje() {
    this._dialogRef.close()
  }

  ngOnDestroy() {
    this._ngUnsubscribe.next()
    this._ngUnsubscribe.complete()
  }
}
